<template>
  <div>
    <v-card>
      <v-container>
        <v-list dense>
          <v-list-item dense v-for="role in roles" :key="role.value"
            :title="role.name"
            :value="role.value"
            >
            <template v-slot:prepend="{ isSelected }">
              <v-list-item-action>
                <v-checkbox-btn
                  hide-details
                  :model-value="selected.indexOf(role.value) > -1"
                  color="primary"
                  @update:model-value="toggleRole($event, role.value)"
                ></v-checkbox-btn>
              </v-list-item-action>

              
                <!-- <v-list-item-title>{{ role.name }}</v-list-item-title> -->
              
            </template>
          </v-list-item>
        </v-list>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="save()" variant="tonal">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { Roles } from '@/common'
export default {
  name: 'RoleImpersonation',
  data() {
    return {
      roles: Object.values(Roles.properties).concat([
        {
          name: 'Additional FYI',
          value: 'additionalFyi'
        },
        {
          name: 'Additional Approver',
          value: 'additionalApprover'
        }
      ]),
      selected: []
    }
  },
  props: {
    mocId: String
  },
  methods: {
    toggleRole(value, role) {
      if (value) {
        this.selected = Array.from(new Set([...this.selected, role]))
      } else {
        const index = this.selected.indexOf(role)
        if (index > -1) this.selected.splice(index, 1)
      }
    },
    save() {
      if (!this.selected.length) {
        sessionStorage.removeItem(this.mocId)
        this.$router.go(0)
        return
      }
      sessionStorage.setItem(this.mocId, JSON.stringify(this.selected))
      this.$router.go(0)
    }
  },
  mounted() {
    const impersonatedRoles = sessionStorage.getItem(this.mocId)
    this.selected = impersonatedRoles ? JSON.parse(impersonatedRoles) : []
  }
}
</script>

<style></style>
